module.exports = __webpack_public_path__ + "static/media/jardinrodin1.2a1e3c4e.JPG";